import Vue from 'vue';
import { createActionHelpers } from 'vuex-loading';
import Service from './service';
import { searchTaxonomyByValue } from './utils';

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});
const CLEAR_MODULE = 'CLEAR_MODULE';
const UPDATE_ERROR = 'UPDATE_ERROR';
const LOAD_TAXONOMY = 'LOAD_TAXONOMY';

const updateTaxonomiesAction = 'updateTaxonomiesAction';

export default {
  namespaced: true,
  state: {
    error: '',
    names: [],
    data: {},
  },
  mutations: {
    [CLEAR_MODULE](state) {
      Vue.set(state, 'names', []);
      Vue.set(state, 'data', {});
    },
    [UPDATE_ERROR](state, payload) {
      Vue.set(state, 'error', payload);
    },
    [LOAD_TAXONOMY](state, payload) {
      const { name, data } = payload;
      if (state.names.indexOf(name) < 0) {
        state.names.push(name);
      }
      Vue.set(state.data, name, data);
    },
  },
  actions: {
    [updateTaxonomiesAction]({ commit, dispatch }) {
      startLoading(dispatch, 'taxonomies');
      return Service.discoverTaxonomies()
        .then((nameList) => {
          const promises = [];
          nameList.forEach((tax) => {
            promises.push(Service.getTaxonomy(tax.value)
              .then(taxList => commit(LOAD_TAXONOMY, { name: tax.value, data: taxList })));
          });
          return Promise.all(promises);
        })
        .then(() => {
          commit(LOAD_TAXONOMY, {
            name: 'tipo_vivienda',
            data: [
              { value: '0', text: 'Vivienda habitual' },
              { value: '1', text: 'Segunda Vivienda' },
            ],
          });
          commit(LOAD_TAXONOMY, {
            name: 'renovable',
            data: [
              { value: '0', text: 'No' },
              { value: '1', text: 'Sí' },
            ],
          });
          commit(LOAD_TAXONOMY, {
            name: 'gestion_inmobiliaria',
            data: [
              { value: '0', text: 'No' },
              { value: '1', text: 'Sí' },
            ],
          });
          commit(LOAD_TAXONOMY, {
            name: 'rango_hipoteca',
            data: [
              { value: '0', text: 'Hipoteca de primer rango' },
              { value: '1', text: 'Hipoteca de segundo rango' },
            ],
          });
          endLoading(dispatch, 'taxonomies');
        })
        .catch(() => {
          commit(UPDATE_ERROR, 'Error en el servicio');
          endLoading(dispatch, 'taxonomies');
        });
    },
  },
  getters: {
    getTaxonomy: state => vid => state.data[vid],
    searchTaxonomyValue: state => (search) => {
      if (state.data[search.vid]) {
        return searchTaxonomyByValue(state.data[search.vid], search.text).value;
      }
      return null;
    },
  },
};



// WEBPACK FOOTER //
// ./src/features/taxonomy/store.js